import styled from '@emotion/styled';

const FormWrapper = styled('form')({
  display: 'flex',
  alignItems: 'flex-start',
});

export default FormWrapper;
